import { FC, ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { RazorPayLogo } from '@components/common/svg-icons';
import Header from './header';
import StepProgressBar from './stepProgress';

const Layout: FC = (): ReactElement => {
  return (
    <div className="relative flex h-screen w-full flex-col">
      <Header />

      <section className="flex-1 overflow-y-auto bg-gray-100">
        <StepProgressBar />
        <Outlet />
      </section>

      <div className="fixed bottom-4 right-4 flex items-center gap-1 rounded bg-white/80 px-2 py-1 shadow">
        <span className="text-sm text-gray-600">Powered by</span>
        <RazorPayLogo />
      </div>
    </div>
  );
};

export default Layout;
